import React from 'react'
import * as S from './TableAddBatch.styles'
import { NumberFmt } from '../../../../../utils'
import dayjs from 'dayjs'

function TableAddNotFoundBatch({ tableData, handleDeleteRow }) {
  return (
    <S.Table>
      <S.THead>
        <S.THeadTR>
          <S.TH>Deletar</S.TH>
          <S.TH>Unid.</S.TH>
          <S.TH>Avariados</S.TH>
          <S.TH>Validade</S.TH>
        </S.THeadTR>
      </S.THead>
      <S.TBody>
        {tableData.map((row, index) => (
          <S.TBodyTR key={index}>
            <S.TD>
              <S.TrashButton handleClick={() => handleDeleteRow(row)} />
            </S.TD>
            <S.TD>
              <NumberFmt
                sufix={row.isKg ? 'KG' : 'UN'}
                digits={row.isKg && 3}
                value={row.total}
              />
            </S.TD>
            <S.TD data-testid="qtd-avaria">
              <NumberFmt
                sufix={row.isKg ? 'KG' : 'UN'}
                value={row.damageQty}
                digits={row.isKg && 3}
              />
            </S.TD>
            <S.TD>{dayjs(row.expirationDate).format('DD/MM/YYYY')}</S.TD>
          </S.TBodyTR>
        ))}
      </S.TBody>
    </S.Table>
  )
}

export default TableAddNotFoundBatch
